module.exports = __webpack_public_path__ + "img/book_4_zh.b932ccb5.png";